const data = {
  id: 1,
  title: 'Listen and choose the correct letter',
  subTitle: 'Nghe và chọn chữ cái chính xác điền vào chỗ trống',
  question: 'p ___ n',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/081d6e94-3524-4e78-a35a-94482d424803.mp3',
  imageUrl: '',
  answers: [
    { id: 1, answer: 'e', isCorrect: true },
    { id: 2, answer: 'a', isCorrect: false },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      //   direction: 'vertical',
      bulletType: 'none',
      // bulletType: 'character',
      // bulletType: 'number',
      // imageAnswers: true, // True là vẽ hình, False hoặc không có là vẽ Button.
      // columnImageAnswers: 2, // Số cột và hình nên đi cặp cùng nhau.
    },
  },
};

export default data;
